<template>
  <div class="error_page">
    <v-alert :value="true" type="error">
      <h3>{{ label }}</h3>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  props: {
    label: String,
    desc: String,
    icon: String,
    iconSize: Number
  }
};
</script>

<style lang="scss">
@import "@/styles/_colours.scss";

div.error_page {
  text-align: center;
}
.md-empty-state-container {
  width: auto !important;
  height: auto !important;
}
.md-empty-state {
  display: inline-block;
  vertical-align: middle;
}
.md-empty-state-icon {
  font-size: 80px !important;
}
.v-alert {
  border: 0px solid white !important;
  &.error {
    background-color: inherit !important;
    h3 {
      color: $grey !important;
    }
  }
}
</style>
